import React, { useState, useEffect } from 'react';
import './Pages.css';

const ApprovedExtensions = () => {
  const [extensions, setExtensions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    fetchApprovedExtensions();
  }, []);

  const fetchApprovedExtensions = async () => {
    try {
      const response = await fetch('https://main.victriedemos.com:3017/api/extensions/status/1');
      const data = await response.json();

      if (data.success) {
        setExtensions(data.data);
      } else {
        setError('Failed to load approved extensions');
      }
    } catch (err) {
      console.error('Error fetching approved extensions:', err);
      setError('Unable to connect to server');
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return 'N/A';
    return date.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
  };

  const formatCurrency = (amount) => {
    if (!amount) return 'N/A';
    return new Intl.NumberFormat('en-KE', {
      style: 'currency',
      currency: 'KES'
    }).format(amount);
  };

  const filteredExtensions = extensions.filter(ext => {
    if (!searchTerm) return true;
    
    const search = searchTerm.toLowerCase();
    const policyNumber = (ext.PolicyNumber || '').toLowerCase();
    const registration = (ext.Registration || '').toLowerCase();
    
    return policyNumber.includes(search) || registration.includes(search);
  });

  if (loading) {
    return (
      <div className="page-container">
        <div className="loading-container">
          <div className="spinner"></div>
          <p>Loading approved extensions...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="page-container">
      <div className="page-header">
        <div>
          <h1>✅ Approved Extensions</h1>
          <p className="page-subtitle">Approved and active policy extensions</p>
        </div>
        <div className="badge-count success">{filteredExtensions.length} Approved</div>
      </div>

      {error && (
        <div className="error-banner">
          {error}
        </div>
      )}

      <div className="search-bar">
        <input
          type="text"
          placeholder="🔍 Search by Policy Number or Registration..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="search-input"
        />
        {searchTerm && (
          <button 
            className="clear-search-btn"
            onClick={() => setSearchTerm('')}
          >
            ✕ Clear
          </button>
        )}
      </div>

      <div className="table-container">
        {filteredExtensions.length === 0 ? (
          <div className="empty-state">
            <p>{searchTerm ? `No extensions found matching "${searchTerm}"` : 'No approved extensions found'}</p>
          </div>
        ) : (
          <table className="data-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Policy Number</th>
                <th>Registration</th>
                <th>Commencement Date</th>
                <th>Expiry Date</th>
                <th>Gross Premium</th>
                <th>Commission</th>
                <th>Date Approved</th>
                <th>Approved By</th>
              </tr>
            </thead>
            <tbody>
              {filteredExtensions.map((ext, index) => (
                <tr key={ext.Id}>
                  <td>{index + 1}</td>
                  <td className="policy-number">{ext.PolicyNumber || 'N/A'}</td>
                  <td>{ext.Registration || 'N/A'}</td>
                  <td>{formatDate(ext.CommencementDate)}</td>
                  <td>{formatDate(ext.ExpiryDate)}</td>
                  <td className="amount">{formatCurrency(ext.GrossPremium)}</td>
                  <td className="amount">{formatCurrency(ext.Commission)}</td>
                  <td>{formatDate(ext.DateDone)}</td>
                  <td>{ext.DoneBy || 'N/A'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default ApprovedExtensions;
